// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CI01G","pdfContainer":"styles_pdfContainer__-LDah"};